import { render, staticRenderFns } from "./tags-page-opened.vue?vue&type=template&id=688e116a&scoped=true"
import script from "./tags-page-opened.vue?vue&type=script&lang=ts"
export * from "./tags-page-opened.vue?vue&type=script&lang=ts"
import style0 from "./tags-page-opened.vue?vue&type=style&index=0&id=688e116a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688e116a",
  null
  
)

export default component.exports